<!-- 去 app商店 -->
<template>
  <div class="goApp">
    <img src="@/assets/global/app-logo.png" class="goApp-logo" @click="goTo">
    <button class="goApp-btn" @click="goTo">{{btnText}}</button>
  </div>
</template>

<script>
export default {
  name: 'GoDownloadRect',
  props: {
    btnText: {
      type: String,
      default: '去收听'
    },
    url: {
      type: String,
      default: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.appshare.android.ilisten&ckey=CK1321531259444'
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    goTo() {
      window.location.href = this.url
    }
  }
}
</script>

<style lang="less" scoped>
.goApp {
  background-color: #fff;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.16);
  width: 100%;
  height: 1.44rem;
  padding: 0 0.32rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &-logo {
    width: 3.17rem;
    height: 0.9rem;
  }
  &-btn {
    height: 0.64rem;
    color: #5b413a;
    font-weight: 700;
    font-size: .26rem;
    background: #fedc42;
    border-radius: 0.32rem;
    padding: 0.12rem 0.36rem;
    outline: none;
    border: none;
  }
}
</style>
